import { useMemo } from "react";

/** Memoizes an entire object
 *
 * The reference of the returned object updates when, and only when,
 * any property changes under shallow equality.
 */
export const useObjectMemo = <T extends object>(value: T) =>
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useMemo(() => value, Object.values(value));
